import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import useVersionInfo from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

import { FetchDatasetParams } from '../../types';

import { Flows } from './types';

const fetchFlows = async (params: FetchDatasetParams) => {
  const { data } = await api.get(`/web/v4/uprs/${params.dataset_id}/flows`, { params });

  return data;
};

const useFlows = (id?: string) => {
  const { ver: version, system_model } = useVersionInfo();
  return useQuery<Flows, AxiosError>({
    queryKey: ['flows', id, version, system_model],
    queryFn: () => fetchFlows({ dataset_id: id as string, version, system_model }),
    enabled: isV4Release(version) && !!id,
    retry: false,
  });
};

export default useFlows;
